// Central config for BM Towing & Recovery site
export const PHONE_DISPLAY = "(425) 647-9585";
export const PHONE_TEL = "+14256479585";
export const EMAIL = "bmtowing425@gmail.com";
export const BUSINESS_NAME = "BM Towing & Recovery";
export const PRIMARY_AREAS = ["Kirkland", "Bellevue"];
export const SERVICE_AREAS = [
  { name: "Bellevue", slug: "bellevue", zip: "WA" },
  { name: "Kirkland", slug: "kirkland", zip: "WA", path: "/kirkland-towing" },
  { name: "Redmond", slug: "redmond", zip: "WA" },
  { name: "Bothell", slug: "bothell", zip: "WA" },
  { name: "Woodinville", slug: "woodinville", zip: "WA" },
  { name: "Sammamish", slug: "sammamish", zip: "WA" },
  { name: "Issaquah", slug: "issaquah", zip: "WA" },
  { name: "Mercer Island", slug: "mercer-island", zip: "WA" },
  { name: "Newcastle", slug: "newcastle", zip: "WA" },
];

// Site URL used for canonical/sitemap/JSON-LD. Falls back to the current
// origin at runtime so the preview and production domains both work.
// To switch to a custom domain, set REACT_APP_SITE_URL in frontend/.env.
export const SITE_URL_FALLBACK = "https://bmtowingrecovery.com";
export function getSiteUrl() {
  if (typeof process !== "undefined" && process.env && process.env.REACT_APP_SITE_URL) {
    return process.env.REACT_APP_SITE_URL.replace(/\/$/, "");
  }
  if (typeof window !== "undefined" && window.location && window.location.origin) {
    return window.location.origin;
  }
  return SITE_URL_FALLBACK;
}

// User's Google Business Profile / Google Maps reviews URL
export const GOOGLE_REVIEWS_URL =
  "https://maps.app.goo.gl/iNHSjWc9UHfhY37H7";
export const GOOGLE_RATING = "4.9";

export const SERVICES = [
  {
    slug: "emergency-towing",
    title: "24/7 Emergency Towing",
    short: "Round-the-clock tow trucks dispatched fast across the Eastside.",
    icon: "clock",
  },
  {
    slug: "flatbed-towing",
    title: "Flatbed Towing",
    short: "Safe flatbed transport for luxury, low-clearance & AWD vehicles.",
    icon: "truck",
  },
  {
    slug: "roadside-assistance",
    title: "Roadside Assistance",
    short: "Fast help when you're stuck on the shoulder or in traffic.",
    icon: "wrench",
  },
  {
    slug: "jump-start",
    title: "Jump Start",
    short: "Dead battery? We'll get you started and back on the road.",
    icon: "zap",
  },
  {
    slug: "car-lockout",
    title: "Car Lockout",
    short: "Locked out of your car? We unlock most vehicles damage-free.",
    icon: "key",
  },
  {
    slug: "tire-change",
    title: "Flat Tire & Tire Change",
    short: "Roadside tire changes and spare installations.",
    icon: "circle",
  },
  {
    slug: "winch-out-service",
    title: "Winch-Out Service",
    short: "Stuck in mud, snow, or a ditch? We pull you out safely.",
    icon: "anchor",
  },
  {
    slug: "equipment-transportation",
    title: "Equipment Transportation",
    short: "Toolboxes, generators, small skid-steers, safes & ATVs on our flatbed.",
    icon: "package",
  },
  {
    slug: "long-distance-towing",
    title: "Long-Distance Towing",
    short: "Scheduled flatbed transports across WA — zero miles added to your car.",
    icon: "map",
  },
];

export const TID = {
  // Nav
  navRoot: "site-nav",
  logo: "site-logo",
  navMenuBtn: "nav-menu-btn",
  navHome: "nav-link-home",
  navServices: "nav-link-services",
  navAreas: "nav-link-areas",
  navAbout: "nav-link-about",
  navContact: "nav-link-contact",
  navCall: "nav-call-btn",
  // Hero
  heroCall: "hero-call-now-btn",
  heroQuote: "hero-request-service-btn",
  // Services
  serviceCard: (slug) => `service-card-${slug}`,
  // Areas
  areaChip: (name) => `area-chip-${name.toLowerCase()}`,
  // Reviews
  googleReviewsBtn: "google-reviews-btn",
  // Contact
  contactForm: "contact-form",
  contactName: "contact-input-name",
  contactEmail: "contact-input-email",
  contactPhone: "contact-input-phone",
  contactService: "contact-input-service",
  contactSubject: "contact-input-subject",
  contactMessage: "contact-input-message",
  contactSubmit: "contact-submit-btn",
  contactSuccess: "contact-success-msg",
  contactError: "contact-error-msg",
  // Mobile bar
  mobileCallBar: "mobile-call-bar",
  mobileCallBtn: "mobile-call-btn",
  mobileQuoteBtn: "mobile-quote-btn",
  mobileShareLocationBtn: "mobile-share-location-btn",
  // Share Location
  heroShareLocationBtn: "hero-share-location-btn",
  contactShareLocationBtn: "contact-share-location-btn",
  // Footer
  footerCall: "footer-call-btn",
};
